import { render, staticRenderFns } from "./AssetManagement.vue?vue&type=template&id=7f85ff12&"
import script from "./AssetManagement.vue?vue&type=script&lang=js&"
export * from "./AssetManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports